import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class ImportService {

  private importedResultsEmitter = new EventEmitter<string[]>();

  constructor() {}

  setImportResults(results: any): void {
    this.importedResultsEmitter.emit(results.data);
  }

  getImportEmitter() {
    return this.importedResultsEmitter;
  }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/service/import.service.ts